
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 27,
  viewBox: "0 0 18 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.46 13.944a.774.774 0 0 0-1.548 0 6.873 6.873 0 0 1-6.866 6.865 6.873 6.873 0 0 1-6.865-6.865.774.774 0 0 0-1.548 0c0 4.378 3.361 7.986 7.64 8.377v2.084H5.4a.774.774 0 1 0 0 1.548h7.293a.774.774 0 0 0 0-1.548H9.82v-2.084c4.278-.391 7.64-3.999 7.64-8.377Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.046 18.9a4.962 4.962 0 0 0 4.956-4.956V4.956A4.961 4.961 0 0 0 9.046 0 4.961 4.961 0 0 0 4.09 4.956v8.988A4.962 4.962 0 0 0 9.046 18.9ZM5.638 4.956a3.412 3.412 0 0 1 3.408-3.408 3.412 3.412 0 0 1 3.408 3.408v8.988a3.412 3.412 0 0 1-3.408 3.408 3.412 3.412 0 0 1-3.408-3.408V4.956Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"18\" height=\"27\" viewBox=\"0 0 18 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M17.4598 13.9439C17.4598 13.5166 17.1133 13.17 16.6858 13.17C16.2583 13.17 15.9118 13.5166 15.9118 13.9439C15.9118 17.7297 12.832 20.8095 9.04608 20.8095C5.26039 20.8095 2.18059 17.7297 2.18059 13.9439C2.18059 13.5166 1.83407 13.17 1.40658 13.17C0.979081 13.17 0.632568 13.5166 0.632568 13.9439C0.632568 18.3224 3.99433 21.9295 8.27207 22.3215V24.4052H5.39978C4.97229 24.4052 4.62578 24.7517 4.62578 25.1792C4.62578 25.6067 4.97229 25.9532 5.39978 25.9532H12.6926C13.1199 25.9532 13.4664 25.6067 13.4664 25.1792C13.4664 24.7517 13.1199 24.4052 12.6926 24.4052H9.82009V22.3215C14.098 21.9297 17.4598 18.3224 17.4598 13.9439Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M9.04581 18.8998C11.7785 18.8998 14.0017 16.6765 14.0017 13.9439V4.95572C14.0017 2.22322 11.7785 0 9.04581 0C6.31331 0 4.09009 2.22322 4.09009 4.95572V13.9439C4.09009 16.6765 6.31331 18.8998 9.04581 18.8998ZM5.63791 4.95572C5.63791 3.07663 7.16672 1.54802 9.04581 1.54802C10.9249 1.54802 12.4537 3.07663 12.4537 4.95572V13.9439C12.4537 15.8229 10.9249 17.3517 9.04581 17.3517C7.16672 17.3517 5.63791 15.8229 5.63791 13.9439V4.95572Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/voice.15ef254d53bac26955fc39e9dd358ef3.svg"),
        {
          React: SvgVoice,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      